module.exports = __webpack_public_path__ + "assets/img/newimgfx.927df954.png";